import { Box, Stack, Typography, useTheme } from '@mui/material';
import { RadioButtonList } from 'components/RadioButtonMenu';
import { Section } from 'components/Section';
import { SingleLangTable } from 'components/Section/SingleLangTable';
import { ILanguage, IPage, boStyle } from 'constants/content.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { getLanguages, getPages } from 'state/reducers/content.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { PlanCard } from 'theme/elements/Cards';

interface IProps {
	plans: IPage[];
}

export const PlansContentApp = ({ plans }: IProps) => {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const languages = useAppSelector(getLanguages);
	const [selectedLanguage, setSelectedLanguage] = useState(languages[0]?.code || 'he');
	const [plansICards, setPlansICards] = useState<any>([]);
	const [dataInTable, setDataInTable] = useState<any>([]);
	const tableHeaderItems = [`${t('page.plans.table.headers.subject')}`, `${t('page.plans.table.headers.text')}`];
	const pages = useAppSelector(getPages);

	const handleChangeLanguage = (event: any) => {
		setSelectedLanguage(event.target.value);
	};

	useEffect(() => {
		if (plans?.length) {
			setPlansICards(plans?.filter((plan) => plan.boStyle === boStyle.PLAN_CARD));
			setDataInTable(plans?.filter((plan) => plan.boStyle !== boStyle.PLAN_CARD));
		}
	}, [plans]);

	return (
		<Stack spacing={7} sx={{}}>
			<RadioButtonList
				options={languages?.map((language: ILanguage) => {
					return { value: language.code, label: language.name };
				})}
				selected={selectedLanguage}
				handleChange={handleChangeLanguage}
			/>
			<Box
				sx={{
					marginBottom: '24px',
					display: 'grid',
					gridGap: '32px',
					gridTemplateColumns: 'repeat(auto-fit, minmax(391px, 1fr))',
					[theme.breakpoints.down('md')]: {
						gridTemplateColumns: '100%',
					},
				}}
			>
				{plansICards.length > 0 &&
					plansICards?.map((plan: any, index: number) => {
						const pagesObj = _.keyBy(pages, 'page');
						const planName = _.get(
							pagesObj,
							`[${plan?.page}].sections[0].fieldGroups[0].fieldGroupItems[0].he`
						);
						return (
							<Stack key={index} spacing={2}>
								<Typography
									variant="h4"
									sx={{ fontWeight: '700', color: 'black', textTransform: 'capitalize' }}
								>
									{`${planName} (${plan.displayTitle})`}
								</Typography>
								<PlanCard
									handleClick={undefined}
									styleObj={{
										width: 'auto',
										flexDirection: 'column',
										boxShadow: '4px 4px 16px rgba(0, 58, 53, 0.6)',
									}}
								>
									{plan?.sections?.map((section: any, index: number) => {
										return (
											<SingleLangTable
												key={index}
												section={section}
												selectedLanguage={selectedLanguage}
												tableHeaderItems={tableHeaderItems}
												tableWith="auto"
												tableCellWidth={'100px'}
												paddingStyle="16px 24px!important"
												planCardId={index}
											/>
										);
									})}
								</PlanCard>
							</Stack>
						);
					})}
			</Box>
			{dataInTable?.length > 0 &&
				dataInTable?.map((item: any) => {
					return (
						<Box key={item.id}>
							{item.sections?.map((section: any, index: number) => {
								return (
									<Section
										key={index}
										section={section}
										style={boStyle.SINGLE_LANGUAGE_PAGE}
										selectedLanguage={selectedLanguage}
									/>
								);
							})}
						</Box>
					);
				})}
		</Stack>
	);
};
